import isNull from 'lodash/isNull';
import omit from 'lodash/omit';
import pickBy from 'lodash/pickBy';

export { deepOmit } from '@spotify/confidence-graphql';

export const isShallowEqual = <T extends { [key: string]: unknown }>(
  objA: T,
  objB: T,
) => {
  if (objA === objB) {
    return true;
  }
  const objAKeys = Object.keys(objA);
  const objBKeys = Object.keys(objB);
  if (objAKeys.length !== objBKeys.length) {
    return false;
  }
  return objAKeys.every(key => key in objB && objA[key] === objB[key]);
};

export const cleanNulls = <T extends object>(input: T | null | undefined) =>
  omit(
    pickBy(input, v => !isNull(v)),
    '__typename',
  );
